import { callTool } from "../api";
import { ratingLineage } from "../ratings";

export type QuickAccountInput = {
  name: string;
  domain?: string;
  website?: string;
  secondaryWebsite?: string;
};

export async function quickCreateAccount(
  eventKey: string,
  actor: string,
  input: QuickAccountInput,
): Promise<{ account_id: string; name: string }> {
  const name = input.name.trim();
  if (!name) throw new Error("Account name is required.");

  const domain = input.domain?.trim() || undefined;
  const website = input.website?.trim() || undefined;
  const secondaryWebsite = input.secondaryWebsite?.trim() || undefined;

  const result = await callTool<{ account_id: string }>("account_upsert", {
    event_key: eventKey,
    name,
    domain,
    website,
    ...(secondaryWebsite ? { secondary_website: secondaryWebsite } : {}),
    actor,
    lineage: ratingLineage(),
    source: "marketing-web",
  });

  const accountId = result.account_id;
  if (!accountId) throw new Error("account_upsert did not return an account_id.");

  return { account_id: accountId, name };
}
